import roles from '../configs/roles';

// eslint-disable-next-line import/prefer-default-export
export const twoFactorStatusTypes = {
  needTotpSetup: 'need_totp_setup',
  needTotpVerification: 'need_totp_verification',
};

export const homeRoutes = {
  [roles.superAdmin.name]: '/manage-petitions',
  [roles.petitionImageViewer.name]: '/viewer',
  [roles.petitionUploader.name]: '/upload-and-scan',
  [roles.reportViewer.name]: '/reports',
  [roles.canvassingOrganizationUser.name]: '/reports',
  [roles.initiativeAdmin.name]: '/manage-petitions',
  [roles.initiativeManager.name]: '/manage-petitions',
  [roles.initiativeOrganizer.name]: '/manage-petitions',
  [roles.dataAssignee.name]: '/review-petitions',
  [roles.auxiliaryTaskSpecialist.name]: '/review-petitions',
  [roles.electionOfficialAdmin.name]: '/manage-petitions',
  [roles.electionOfficialAssignee.name]: '/review-petitions',
};
